import CollectionBreadcrumb from "components/Collection/CollectionBreadcrumb"

import MobileTitleBar from "components/MobileTitleBar"
import ProductCard from "components/Product/ProductCard"
import { observer } from "mobx-react"
import React, { Component } from "react"
import Responsive from "react-responsive"
import { browserHistory } from "react-router-dom"
import _ from "lodash"
import { Card, Container, Dropdown, Menu, Visibility } from "semantic-ui-react"
import shop from "shop/shop"
import productStore from "stores/productStore"
import cmsStore from "stores/cmsStore"
import WordPress from "WordPress"
import "./CollectionPage.scss"

@observer
export default class ExplorerPage extends Component {

	state = {
		products: [],
		currentOffset: 0,
		sort: "des"
	}

	componentDidMount() {
		this.loadNext()
	}

	componentWillReceiveProps( props ) {
		console.log( "reload" )
		this.reset( props )
	}

	setSort = ( e, {value} ) => {
		this.setState( {sort: value} )
		this.reset()
	}

	reset = ( props ) => {
		this.setState( {currentOffset: 0, products: []}, () => this.loadNext( props ) )
	}

	loadNext = ( props = this.props ) => {
		if ( this.state.loading ) return
		this.setState( {loading: true} )
		let {categoryId} = props.match.params
		let category = shop.categoriesById.get( categoryId )
		const query = {
			query: "",
			page: this.state.currentOffset + 1,
			count: 8,
			sort: this.state.sort
		}

		console.log('explorer page load');
		productStore.fromCategory( categoryId, query )
			.then( res => {
				let {products} = res
				if ( products.length === 0 ) {
					if ( products.length === 0 && shop.config.collections.showProductsFromSubCategories ) {
						// get products from all child categories
						const ids = _.flatten( category && category.children.map( mapChildren ) )
						if ( ids.length > 0 ) {
							return productStore.fromCategory( ids, query )
						}
					}
				}
				return res
			} )
			.then( res => {
				// Merge and filter out duplicate products by map_id
				const mergedProducts = _.uniqBy(
					this.state.products.concat(...res.products),
					'map_id'
				)
				this.setState( {
					currentOffset: this.state.currentOffset + 1,
					loading: false,
					size: res.size,
					products: mergedProducts
				} )
			} )
			.catch( err => {
				console.error( "ERROR", err )
				this.setState( {
					loading: false
				} )
			} )
	}

	render() {
		let {categoryId} = this.props.match.params
		const {loading} = productStore
		const {products, size} = this.state
		let page = cmsStore.contentByCategory.get( categoryId )
		//console.log( "ExplorerPage render", categoryId, page, products )
		return (
			<div className="ExplorerPage">
				<MobileTitleBar>
					<div className="fr">{this.state.size} Stück</div>
					<CollectionBreadcrumb id={categoryId}/>
				</MobileTitleBar>

				<Container className="pt4 pb5 ">
					<Responsive minWidth={790}>
						{page && <WordPress page={page}/>}
						<div className="pb4   z-99 relative">
							<div className="fr">
								<div className="dib pr3">
									<SelectSort value={this.state.sort} onChange={this.setSort}/>
								</div>
								{this.state.size} Stück
							</div>

							<div className="pt3">
								<CollectionBreadcrumb id={categoryId}/>
							</div>

						</div>
					</Responsive>
					<ProductMapper products={products} onEnd={this.loadNext}/>
				</Container>
			</div>
		)
	}
}

const sortOptions = [
	{
		text: "A-Z",
		value: "des"
	},
	{
		text: "Artikel-Nr.",
		value: "article_nr"
	},

	{
		text: "Niedrigster Preis",
		value: "price&dir=asc"
	},
	{
		text: "Höchster Preis",
		value: "price&dir=desc"
	},
	{
		text: "Neuheit",
		value: "extra:neuheit&dir=asc"
	},
	{
		text: "Topseller",
		value: "topseller"
	}
]
const SelectSort = ( {value, onChange} ) => (
	<Menu compact>
		<Dropdown size="small" closeOnChange value={value} options={sortOptions} item onChange={onChange}/>
	</Menu>
)


class ProductMapper extends Component {

	handleUpdate = ( e, {calculations} ) => {
		if ( calculations.topVisible ) this.props.onEnd()
	}

render() {
    const {products} = this.props
    let l = products.length
    //console.log( "ProductMapper render", l, products )
    return (
        <Card.Group itemsPerRow="4" doubling>
            {products.map((product, key) =>
                <ProductCard key={product.map_id} product={product}/>
            )}
            <Visibility fireOnMount onUpdate={this.handleUpdate}/>
        </Card.Group>
    )
}


}

const mapChildren = cat => {
	if ( cat.children.length > 0 ) return _.map( cat.children, mapChildren )
	return cat.map_id
}



// WEBPACK FOOTER //
// ./src/pages/ExplorerPage.js